<template>
  <div class="sub-footer">
    <div class="grid-container fluid">
      <div class="grid-x align-center">
        <div class="cell large-11 medium-10 text-right">
          <router-link :to="nextRoute.path">
            <div class="sub-footer__text-wrapper right">
              <p class="sub-footer__text"
                 data-aos="fade-down"
                 data-aos-offset="0"
                 v-text="getFooterText()">
              </p>
              <div class="sub-footer__arrow-wrapper"
                   data-aos="fade-right"
                   data-aos-duration="400"
                   data-aos-offset="0">
                <img class="sub-footer__arrow sub-footer__arrow_hidden"
                     alt="Continue"
                     src="../../assets/footer-arrow.png"
                     style="left: 0px;"/>
                <img class="sub-footer__arrow"
                     alt="Continue"
                     src="../../assets/footer-arrow.png"
                     style="left: 400px;"/>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TheSubFooter',
  props: {
    nextRoute: Object
  },
  methods: {
    getFooterText: function () {
      let footerText = '';
      if (this.nextRoute.index !== 0) footerText = 'Continue to ';
      return footerText + this.nextRoute.name;
    }
  }
};
</script>

<style lang="scss" scoped>
  @import "../../styles/setup/variables";
  .sub-footer {
    background-color: $purp;
    padding: 50px 0;
    a {
      color: $white;
      display: inline-block;
      outline: 0;
    }
    img {
      display: inline-block;
      height: 20px;
      margin: 0;
      width: 140px;
    }
    p {
      font-family: $sans-serif;
      font-weight: $sans-serif-weight;
    }
    .sub-footer__text-wrapper {
      .sub-footer__text {
        font-weight: bold;
        display: inline-block;
        font-size: 14px;
        letter-spacing: 3px;
        margin-right: 30px;
        margin-bottom: 0;
        text-transform: uppercase;
      }
    }

    .sub-footer__arrow-wrapper {
      cursor: pointer;
      display: inline-block;
      height: 20px;
      margin: 0 30px 0 45px;
      position: relative;
      overflow: hidden;
      top: 5px;
      width: 150px;

      .sub-footer__arrow {
        position: absolute;
        left: 0;

        &.sub-footer__arrow_hidden {
          position: absolute;
          left: -300px;
        }
      }
      @include breakpoint(medium up){
        margin: 0 0 0 24px;
      }
    }
  }
</style>
